/**
 * The vocabulary the form pickers share, kept apart from `widgetRegistry` so the logic that decides which forms to
 * offer can be imported without pulling in every card component behind it.
 */

export type CardOption = { label: string; value: string };

/** The editable ICS-201, offered in place of the read-only `initialResponse` PDF widget. */
export const ICS_201_WIDGET_NAME = 'ics201';

/**
 * Dropdown entry for the editable ICS-201.
 *
 * Kept out of `WIDGET_TITLES` because that list drives the Planning P picker, whose ICS-201 entry is the read-only
 * `initialResponse` briefing. Surfaces that want the card opt in by adding this option.
 */
export const ICS_201_CARD_OPTION: CardOption = {
  value: ICS_201_WIDGET_NAME,
  label: 'Incident Briefing ICS-201',
};
